/**
 * Offline-First Inspection Creator
 *
 * Handles creating new inspections entirely client-side
 * No server calls until sync
 */

import inspectionStorage from '../utils/inspection_storage.js';

class InspectionCreator {
  /**
   * Create a new inspection offline-first
   * @param {number} propertyId - Property ID
   * @param {string} propertyAddress - Property address for display
   * @returns {Promise<string>} - Inspection UUID
   */
  async createInspection(propertyId, propertyAddress) {
    try {
      console.log('📝 Creating new offline inspection for property:', propertyId);

      // Generate UUID client-side (no server call)
      const uuid = this.generateUUID();
      console.log('✅ Generated UUID:', uuid);

      // Create inspection data structure
      const inspectionData = {
        uuid: uuid,
        property_id: propertyId,
        status: 'draft',
        responses: {
          property_address: propertyAddress
        },
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };

      // Save to IndexedDB only (no server)
      await inspectionStorage.saveInspection(uuid, inspectionData);
      console.log('✅ Inspection saved to IndexedDB:', uuid);

      return uuid;
    } catch (error) {
      console.error('❌ Error creating inspection:', error);
      throw error;
    }
  }

  /**
   * Generate a UUID v4
   * @returns {string} - UUID
   */
  generateUUID() {
    // Use crypto.randomUUID if available (modern browsers)
    if (crypto.randomUUID) {
      return crypto.randomUUID();
    }

    // Fallback to manual generation
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

// Export singleton instance
export default new InspectionCreator();
